import { render, staticRenderFns } from "./ResBanner.vue?vue&type=template&id=915259b0&scoped=true&"
import script from "./ResBanner.vue?vue&type=script&lang=js&"
export * from "./ResBanner.vue?vue&type=script&lang=js&"
import style0 from "./ResBanner.vue?vue&type=style&index=0&id=915259b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915259b0",
  null
  
)

export default component.exports